import { Position, Tournament } from '@/views/interfaces/entities.ts';
import {
  APITournamentToTournament,
  tournamentToAPITournament,
  positionsToAPIPositions,
  APITournamentsToTournaments,
} from '@/views/mappers/TournamentMapper';
import axios from 'axios';
import { TournamentState } from 'vue';
import { ActionTree } from 'vuex';
import { types } from './mutations';

const ENV = process.env.NODE_ENV;
const BASE_URL =
  ENV === 'production'
    ? 'https://elimination-tournament.onrender.com/api/v2/'
    : 'http://localhost:3000/api/v2/';
const TOURNAMENT_URL = BASE_URL + 'tournaments';
const POSITION_URL = BASE_URL + 'positions';

const actions: ActionTree<TournamentState, any> = {
  update: (context: { state: TournamentState; commit; rootState }) => {
    const { commit, rootState } = context;
    const params = rootState.route.query;
    return axios.get('', { params }).then((response) => {
      commit('SET_LIST', response.data);
    });
  },
  updateScreen: ({ commit }) => {
    commit(types.UPDATE_ELEMENT);
  },

  list: async ({ commit }): Promise<void> => {
    await axios.get(`${TOURNAMENT_URL}`, { params: { status: 'started' } }).then((response) => {
      const trending: Tournament[] = APITournamentsToTournaments(response.data.results);
      commit(types.SET_TRENDING, trending);
    });
    await axios.get(`${TOURNAMENT_URL}`, { params: { status: 'ended' } }).then((response) => {
      const ended: Tournament[] = APITournamentsToTournaments(response.data.results);
      commit(types.SET_ENDED, ended);
    });
  },

  save: ({ commit }, data: Tournament) => {
    const apiTournament = tournamentToAPITournament(data);
    if (apiTournament.id) {
      return axios.put(`${TOURNAMENT_URL}/${apiTournament.id}/`, apiTournament).then((response) => {
        console.info('updated tournament', { response });
      });
    }
    // creation will create tournament as draft and with all its positions
    return axios.post(`${TOURNAMENT_URL}/`, apiTournament).then((response) => {
      const tournament = APITournamentToTournament(response.data);
      commit(types.SET_TOURNAMENT, tournament);
      console.info('created tournament', { response });
    });
  },

  get: async ({ commit }, tournamentId: number): Promise<void> =>
    await axios.get(`${TOURNAMENT_URL}/${tournamentId}`).then((response) => {
      const tournament: Tournament = APITournamentToTournament(response.data);
      commit(types.SET_TOURNAMENT, tournament);

    }),

  selectMatch: ({ commit }, parentPosIndex: number) => commit(types.SELECT_MATCH, parentPosIndex),

  resetMatch: ({ commit }) => commit(types.RESET_MATCH),
  
  incrementView: ({ getters }) => {
    const { id, views } = getters.getTournament;
    return axios.put(`${TOURNAMENT_URL}/${id}/`, { views: views + 1 });
  },

  vote: ({ getters }, positionId: number) => {
    return axios.put(`${POSITION_URL}/${positionId}/score/`).then(() => {
      console.log(`position ${positionId} scored`);
    });
  },

  savePosition: ({}, position: Position) => {
    const apiPosition = positionsToAPIPositions([position])[0];
    return axios
      .put(`${POSITION_URL}/${position.id}/`, apiPosition)
      .then(() => console.info('Updated position'));
  },
};

export default actions;
